import { apiRequest } from "@/network/apiClient";
import { useState, useEffect } from "react";
import { API_ENDPOINTS } from "../apiEndpoints";

export const useGetReferrerList = (leadSource) => {
    const [referrerList, setReferrerList] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setIsLoading(true);
        setError(null);

        try {
            // Add lead_source as a query parameter
            const url = `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.REFERRER_LIST}?lead_source=${encodeURIComponent(leadSource)}`;
            const result = await apiRequest(url, 'GET')
            setReferrerList(result)
        } catch (error) {
            setError(error.message);
            console.error('Error fetching data: ', error);
        } finally {
            setIsLoading(false);
        }
    };

    // useEffect(() => {
    //     // Only fetch if leadSource is provided
    //     if (leadSource) {
    //         fetchData();
    //     }
    // }, [leadSource]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!leadSource) return;
                const url = `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.REFERRER_LIST}?lead_source=${encodeURIComponent(leadSource)}`;
                const result = await apiRequest(url, 'GET')
                setReferrerList(result)
            } catch (error) {
                console.error('Error fetching data: ', error)
            }
        };
    
        fetchData();
    }, [leadSource]);

    return { referrerList }
}